module.exports = __webpack_public_path__ + "static/media/serenedry-4.8f8262d4.png";